import { useEffect, useState, useRef } from "react";
import styled, { ThemeProvider } from "styled-components";
import Menu from "./components/Menu";
import Navbar from "./components/Navbar";
import { darkTheme, lightTheme } from "./utils/Theme";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Video from "./pages/Video";
import SignIn from "./pages/SignIn";
import BIRDS from 'vanta/dist/vanta.waves.min';

const Background = styled.div`
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: -1;
`;

const Container = styled.div`
  position: relative;
  display: flex;
  min-height: 100vh;
`;

const Main = styled.div`
  flex: 7;
  position: relative;
  z-index: 1;
`;

const Wrapper = styled.div`
  padding: 22px 20px; // Adjusted for smaller screens by default

  @media (min-width: 768px) {
    padding: 22px 48px; // Medium screens
  }

  @media (min-width: 1024px) {
    padding: 22px 96px; // Larger screens
  }
`;

function App() {
  const [darkMode, setDarkMode] = useState(true);
  const vantaRef = useRef(null);

  useEffect(() => {
    const vantaColor = darkMode ? 0x000000 : 0x9ba9a9; // Set color based on theme
    let vantaEffect = BIRDS({
      el: vantaRef.current,
      color: vantaColor, // Use the dynamically determined color
      shininess: 80,
      waveHeight: 20,
      waveSpeed: 0.5,
      zoom: 0.85
    });
  
    return () => {
      if (vantaEffect) vantaEffect.destroy();
    };
  }, [darkMode]); // Ensuring effect re-initializes if darkMode changes

  return (
    <ThemeProvider theme={darkMode ? darkTheme : lightTheme}>
      <Background ref={vantaRef} />
      <Container>
        <BrowserRouter>
          <Menu darkMode={darkMode} setDarkMode={setDarkMode} />
          <Main>
            <Navbar />
            <Wrapper>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="signin" element={<SignIn />} />
                <Route path="video/:id" element={<Video />} />
              </Routes>
            </Wrapper>
          </Main>
        </BrowserRouter>
      </Container>
    </ThemeProvider>
  );
}

export default App;
